import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/ResizeGroup/ResizeGroupUsage.mdx";

import Examples from "../../Docs/Components/ResizeGroup/ResizeGroupExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="ResizeGroup"
            description="A resize group allows you to show and hide controls dynamically as the container size changes."
            apiSources={["azure-devops-ui/Components/ResizeGroup/ResizeGroup.Props.d.ts"]}
            examples={Examples}
            usage={Usage}
        />
    );
}
}
        
export default Page;